import {Link, Observer, PageContainer, RunInAction} from "web-vcore";
import moment from "moment";
import {Button, Column, Div, Grid, Row, Text} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {GetStories, Story} from "../../Server/DB/stories.js";
import {User} from "../../Server/DB/users/@User.js";
import {store} from "../../Store/index.js";
import {GetSelectedStory} from "../../Store/main/content.js";
import {ES} from "web-vcore";
import {StoryUI} from "./Stories/StoryUI.js";
import {Me, MeID} from "../../Server/DB/users.js";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel.js";
import {CE, E, StartUpload} from "js-vextensions";
import {AddStory} from "../../Server/Commands/StoryCommands.js";
import {AddStoryMessage} from "../../Server/Commands/StoryMessageCommands.js";
import {StoryMessage} from "../../Server/DB/storyMessages/@StoryMessage.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {styles} from "../../Utils/UI/GlobalStyles.js";

export const StoriesUI = observer_mgl((props: {user: User})=>{
	const {user} = props;
	const entries = GetStories(user.id).filter(a=>a && a.creator == MeID()) // defensive (temp)
		.OrderByDescending(a=>a.createdAt);
	const selectedEntry = GetSelectedStory();

	const largeVersion = window.outerWidth >= 1024;
	if (!largeVersion) {
		return (
			<PageContainer preset="full" style={{...styles.pageContainer, margin: 0, padding: 0, background: "none"}}>
				{selectedEntry == null && <EntryList {...{entries, selectedEntry}}/>}
				{selectedEntry != null && <StoryUI entry={selectedEntry}/>}
			</PageContainer>
		);
	}

	return (
		<PageContainer style={{...styles.pageContainer, flex: 1, flexDirection: "row", margin: 20, padding: 0, background: "none"}}>
			<EntryList {...{entries, selectedEntry}}/>
			<Column ml={10} style={ES({flex: 70})}>
				{selectedEntry && <StoryUI entry={selectedEntry}/>}
			</Column>
		</PageContainer>
	);
});

export function EntryList(props: {entries: Story[], selectedEntry: Story|n}) {
	const {entries, selectedEntry} = props;
	return (
		<Column style={ES({flex: 30})}>
			<Column className="clickThrough" style={{height: 70, background: "rgba(0,0,0,.7)", borderRadius: "10px 10px 0 0"}}>
				<Grid single centerY style={{height: 40, padding: 10}}>
					<Text style={{justifySelf: "center", fontSize: 18}}>Your stories</Text>
					<Row style={{justifySelf: "right"}}>
						<Button mdIcon="file-import-outline" title="Import from JSON file" onClick={async()=>{
							if (Me() == null) return ShowSignInPopup();
							const file = (await StartUpload(false))[0];
							const data = JSON.parse(await file.text());
							const story = new Story({title: "ImportedStory_" + data.story.title});
							console.log("Adding story:", story);
							const {id: newStoryID} = await new AddStory({entry: story}).RunOnServer();

							const messageMappings = {};
							// add messages
							for (const message of data.messages) {
								// "as any" since the importer is legacy code we aren't actually using anymore
								const newMessage = new StoryMessage({...CE(message).ExcludeKeys("_id", "story")} as any);
								newMessage.story = newStoryID;
								if (newMessage.parent) newMessage.parent = messageMappings[newMessage.parent];
								console.log("Adding message:", newMessage);
								const newID = await new AddStoryMessage({entry: newMessage}).RunOnServer();
								messageMappings[message._id] = newID;
							}

							RunInAction("EntryList.addEntry.onClick", ()=>store.main.content.selectedStory = newStoryID);
						}}/>
						<Button ml={5} mdIcon="plus" onClick={async()=>{
							if (Me() == null) return ShowSignInPopup();
							const story = new Story({title: "New Story"});
							const {id: newStoryID} = await new AddStory({entry: story}).RunOnServer();
							RunInAction("EntryList.addEntry.onClick", ()=>store.main.content.selectedStory = newStoryID);
						}}/>
					</Row>
				</Grid>
				<Row style={{height: 30, padding: 10}}>
					<span style={{flex: columnWidths[0], fontWeight: 500, fontSize: 15}}>Title</span>
					<span style={{flex: columnWidths[1], fontWeight: 500, fontSize: 15}}>Created at</span>
				</Row>
			</Column>
			<ScrollView style={{flex: 1}} contentStyle={{backgroundColor: "rgba(30,30,30,.7)", borderRadius: "0 0 10px 10px"}} onClick={e=>{
				if (e.target != e.currentTarget) return;
				RunInAction("EntryList.background.onClick", ()=>store.main.content.selectedStory = null);
			}}>
				{entries.length == 0 && <div style={{textAlign: "center", fontSize: 18}}>No entries.</div>}
				{entries.map((entry, index)=>{
					return <StoryEntryRow key={index} entry={entry} entries={entries} selected={entry.id == selectedEntry?.id}/>;
				})}
			</ScrollView>
		</Column>
	);
}

export const columnWidths = [.7, .3];

export function StoryEntryRow(props: {entry: Story, entries: Story[], selected: boolean}) {
	const {entry, entries, selected} = props;
	//const index = entries.indexOf(entry);
	return (
		<Link style={ES(
			{
				display: "flex", flexDirection: "column", // this is needed for background-color to show properly
				fontSize: 13, whiteSpace: "pre",
			},
			selected && {backgroundColor: "rgba(255,255,255,.15)"},
		)} actionFunc={s=>s.main.content.selectedStory = entry.id} onContextMenu={e=>e.nativeEvent["passThrough"] = true}>
			<Div style={{position: "relative", flex: columnWidths[0]}}>
				<Text style={{fontSize: 17}}>{entry.title.trim().length ? entry.title : "(unnamed)"}</Text>
			</Div>
			<span style={{flex: columnWidths[1]}}>{moment(entry.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>
		</Link>
	);
}